import {Injectable} from "@angular/core";
import {NestApiProvider} from "../../nest-api";
import {Observable} from "rxjs";

@Injectable()
export class StandardizedDataAPiProvider {

  private _service: string = 'setting';
  private _model: string = 'standardizedData';

  constructor(
    private nestApiProvider: NestApiProvider
  ) {

  }

  public getStandardizedData(companyId: string): Observable<any> {
    const _method: string = 'GET';
    const _func: string = 'setting';
    const _params: any = {};
    const _urlParams: any = {companyId: companyId};
    const _body: any = {};
    const _url = this.nestApiProvider.urlBuilder(_method, this._model, _func, _params, _urlParams, this._service);
    return this.nestApiProvider.request(_method, _url, _func, _urlParams, _body);
  }

  public setStandardizedData(companyId: string, data: any): Observable<any> {
    console.log("data send standar", data);
    const _method: string = 'POST';
    const _func: string = 'setting';
    const _params: any = data;
    const _urlParams: any = {companyId: companyId};
    const _body: any = {};
    if (typeof companyId !== 'undefined' && companyId !== null) _urlParams.companyId = companyId;
    const _url = this.nestApiProvider.urlBuilder(_method, this._model, _func, {}, _urlParams, this._service);
    return this.nestApiProvider.request(_method, _url, _params, _urlParams, _body);
  }

}



// WEBPACK FOOTER //
// ./src/shared/nestjs/setting/standardized-data/standardized-data.ts